import React, {useContext, useEffect, useState, useRef} from "react";
import {useReactToPrint} from 'react-to-print';
import {tz} from "moment-timezone";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import AuthContext from "../../store/auth-context";
import useRequest from "../../hooks/use-request";
import Notification from "../../components/Notifications/Notification";
import Table from "../../components/Table/Table";
import LocalPrintshopIcon from '@mui/icons-material/LocalPrintshop';
import VisibilityIcon from '@mui/icons-material/Visibility';
import {
    TableCell,
    TableRow,
} from "@mui/material";
import Loading from "../../components/Loading/Loading";
import Pagination from "../../components/Pagination/Pagination";
import "./address.css";
import Button from "@mui/material/Button";
import LoadingButton from "@mui/lab/LoadingButton";

const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    padding: "20px",
    maxHeight: "90%",
    bgcolor: "background.paper",
    border: "2px solid #000",
    boxShadow: 24,
    p: 4,
    overflow: "auto",
};
const Address = () => {
    const [createUser, setCreateUser] = useState(false);
    const [updateUser, setUpdateUser] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [count, setCount] = useState(0);
    const [allPages, setAllPages] = useState(0);
    const [answers, setAnswers] = useState([]);
    const [answer, setAnswer] = useState({});
    const [onSuccessMsg, setOnSuccessMsg] = useState(null);
    const authCtx = useContext(AuthContext);
    const [open, setOpen] = useState(false);
    // tz("Asia/Tashkent").format("YYYY-MM-DD")
    const [orderId, setOrderId] = useState("");
    const componentRef = useRef();
    const [address, setAddress] = useState("");
    const [lat, setLat] = useState("");
    const [lng, setLng] = useState("");
    const [addressType, setAddressType] = useState("");
    const [users, setUsers] = useState([]);

    useEffect(() => {
        getAnswers.doRequest();
    }, [currentPage]);
    const getAnswers = useRequest({
        url: `/address/pagination?phone=${orderId}&limit=20&page=${currentPage}`,
        method: "get",
        headers: {
            Authorization: `Bearer ${authCtx.token}`,
        },
        onSuccess: (data) => {
            setCount(data.totalCount);
            setAllPages(data.totalPages);
            setCurrentPage(Number(data.page))
            setAnswers(data.data);
        },
    });

    const searchAnswers = useRequest({
        url: `/address/pagination?phone=${orderId}&limit=20&page=${1}`,
        method: "get",
        headers: {
            Authorization: `Bearer ${authCtx.token}`,
        },
        onSuccess: (data) => {
            setCount(data.totalCount);
            setAllPages(data.totalPages);
            setCurrentPage(Number(data.page))
            setAnswers(data.data);
        },
    });
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);
    const handlePrint = useReactToPrint({
        content: () => componentRef.current,
    });

    const changeCurrentPage = (page) => {
        setCurrentPage(page);
    };

    const updateAddressRequest = useRequest({
        url: `/address/${answer.id}`,
        method: "put",
        headers: {
            Authorization: `Bearer ${authCtx.token}`,
        },
        body: {
            address: address,
            lat: lat,
            lng: lng,
            type: addressType,
        },
        onSuccess: (data) => {
            setOnSuccessMsg("Address updated successfully");
            getAnswers.doRequest();
        },
    });

    const deleteAddressRequest = useRequest({
        url: `/address`,
        method: "delete",
        headers: {
            Authorization: `Bearer ${authCtx.token}`,
        },
        onSuccess: (data) => {
            setOnSuccessMsg("Address deleted successfully");
            getAnswers.doRequest();
        },
    });

    const deleteAddress = async (id) => {
        if (window.confirm("Are you sure?")) {
            await deleteAddressRequest.doRequest(id);
            setOnSuccessMsg(null);
        }
    };

    const updateAddress = (id) => {
        setAnswer(answers.find((item) => item.id === id));
        answers.find((item) => {
            if (item.id === id) {
                setAddress(item.address);
                setLat(item.lat);
                setLng(item.lng);
                setAddressType(item.type);
            }
            setUpdateUser(true);
            setCreateUser(true);
        })
    }

    const onSubmitAddressData = async (e) => {
        e.preventDefault();
        await updateAddressRequest.doRequest();
    };
    return (<React.Fragment>
        {getAnswers.loading ? <Loading/> : null}
        {deleteAddressRequest.loading ? <Loading/> : null}
        {onSuccessMsg ? <Notification message={onSuccessMsg} status={"success"}/> : null}
        <div className="profile-container">

            <Modal
                open={open}
                onClose={handleClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={style}>
                    <div className={"document-view"} ref={componentRef}>
                        <table>
                            <thead>
                            <tr>
                                <th>N: </th>
                                <th>User Phone</th>
                            </tr>
                            </thead>
                            <tbody>
                            {users.map((user, index) =>
                                <tr key={index}>
                                    <td>
                                        <div>
                                            <h4>{index+1}</h4>
                                        </div>
                                    </td>
                                    <td>
                                        <div>
                                            <h4>{user}</h4>
                                        </div>
                                    </td>
                                </tr>
                            )}

                            </tbody>
                        </table>
                    </div>
                </Box>
            </Modal>

            <div className="right-section">
                <div className={"sorting"}>

                    <div className={"search-sorting"}>
                        <div className={"search-sorting-body"}>
                            <div className={"sorting-body-item"}>
                                <input type="number" value={orderId} onChange={(e) => {
                                    setOrderId(e.target.value);
                                }}
                                       placeholder={"Input user phone"}/>
                            </div>
                            <div className={"sorting-body-item"}>
                                <Button variant="contained" onClick={() => {
                                    searchAnswers.doRequest();
                                }}>Search</Button>
                            </div>
                        </div>
                    </div>
                </div>
                {!createUser ? <>
                    <Table
                        headers={[
                            "userId",
                            "userPhone",
                            "address",
                            "latitude",
                            "longitude",
                            "type",
                            "approved",
                            "disapproved",
                            "edit",
                            "delete"
                        ]}
                    >
                        {answers.map((n) => (
                            <TableRow
                                key={n.id}
                                sx={{
                                    "&:last-child td, &:last-child th": {
                                        border: 0,
                                    },
                                }}
                            >
                                <TableCell component="th" scope="row">
                                    {n.userId}
                                </TableCell>
                                <TableCell component="th" scope="row">
                                    {n.user.phone}
                                </TableCell>
                                <TableCell component="th" scope="row">
                                    {n.address}
                                </TableCell>
                                <TableCell component="th" scope="row">
                                    {n.lat}
                                </TableCell>
                                <TableCell component="th" scope="row">
                                    {n.lng}
                                </TableCell>
                                <TableCell component="th" scope="row">
                                    {n.type}
                                </TableCell>
                                <TableCell component="th" scope="row">
                                    <Button variant="contained" disabled={n.approvedUsers.length > 0 ? false: true} onClick={() => {setUsers(n.approvedUsers); handleOpen()}}>{n.approved}</Button>
                                </TableCell>
                                <TableCell component="th" scope="row">
                                    <Button variant="contained" disabled={n.disapprovedUsers.length > 0 ? false: true} onClick={() => {setUsers(n.disapprovedUsers); handleOpen()}}>{n.disapproved}</Button>
                                </TableCell>
                                <TableCell component="th" scope="row">
                                    <Button variant="contained" onClick={() => updateAddress(n.id)}><EditIcon/></Button>
                                </TableCell>
                                <TableCell component="th" scope="row">
                                    <Button variant="contained" style={{backgroundColor: "rgb(255, 94, 94)"}} onClick={() => deleteAddress(n.id)}><DeleteIcon/></Button>
                                </TableCell>
                                {/*<TableCell component="th" scope="row">*/}
                                {/*    <Button variant="contained" onClick={handlePrint}><LocalPrintshopIcon/></Button>*/}
                                {/*</TableCell>*/}
                            </TableRow>
                        ))}
                    </Table>

                    <div className="pagination" style={{alignItems: 'center'}}>
                        <Pagination
                            className="pagination-bar"
                            currentPage={currentPage}
                            currentPage={currentPage}
                            totalCount={count}
                            pageSize={allPages}
                            onPageChange={(page) => changeCurrentPage(page)}
                        />
                    </div>
                </> : (<div className="right-section-details">
                    <form onSubmit={onSubmitAddressData}>
                        <div className="detail">
                            <label>Address</label>
                            <input
                                type={"text"}
                                value={address}
                                onChange={(e) => setAddress(e.target.value)}
                                required={true}
                            />
                        </div>
                        <div className="detail">
                            <label>Latitude</label>
                            <input
                                type={"text"}
                                value={lat}
                                onChange={(e) => setLat(e.target.value)}
                                required={true}
                            />
                        </div>
                        <div className="detail">
                            <label>Longitude</label>
                            <input
                                type={"text"}
                                value={lng}
                                onChange={(e) => setLng(e.target.value)}
                            />
                        </div>
                        <div className="detail">
                            <label>Type</label>
                            <input
                                type={"text"}
                                value={addressType}
                                onChange={(e) => setAddressType(e.target.value)}
                            />
                        </div>
                        <div style={{margin: "20px 0"}}>
                            <LoadingButton
                                className="btn"
                                loading={updateAddressRequest.loading}
                                type="submit"
                                variant="contained"
                            >
                                Save Changes
                            </LoadingButton>
                        </div>
                    </form>
                </div>)}

            </div>
        </div>
    </React.Fragment>);
};

export default Address;
